import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { map, isArray } from 'lodash';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  tabs: {
    fontWeight: 'bold',
    userSelect: 'none',
    width: 'fit-content',
    color: theme.palette.white,
    borderTopLeftRadius: '7px',
    borderTopRightRadius: '7px',
    backgroundColor: theme.palette.primary.main,
  },
  tab: {
    cursor: 'pointer',
    transition: '300ms',
    padding: '20px 28px',
    color: theme.palette.white,
    '&:hover': {
      borderTopLeftRadius: '7px',
      borderTopRightRadius: '7px',
      color: theme.palette.black,
      backgroundColor: theme.palette.white,
    },
  },
  activeTab: {
    borderTopLeftRadius: '7px',
    borderTopRightRadius: '7px',
    color: theme.palette.black,
    backgroundColor: theme.palette.white,
  },
}));

const Tabs = ({ items, currentTab, handleCurrentTab }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <Box display="flex" className={classes.tabs}>
      {isArray(items)
        ? map(items, (tab) => (
            <Box
              key={tab}
              onClick={() => handleCurrentTab(tab)}
              className={clsx(
                classes.tab,
                currentTab === tab && classes.activeTab,
              )}>
              {t(tab)}
            </Box>
          ))
        : map(items, (val, key) => (
            <Box
              key={key}
              onClick={() => handleCurrentTab(key)}
              className={clsx(
                classes.tab,
                currentTab === key && classes.activeTab,
              )}>
              {t(val)}
            </Box>
          ))}
    </Box>
  );
};

Tabs.defaultProps = {
  items: [],
};

Tabs.propTypes = {
  currentTab: PropTypes.string,
  handleCurrentTab: PropTypes.func.isRequired,
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default memo(Tabs);
